/**
 * Bridges access tokens from `handleRedirectPromise()` (app `main.tsx`) into React so the
 * auth guard can avoid `acquireTokenSilent` and rely on interactive Entra redirects only.
 */
let pendingAccessToken: string | null = null

export function setMsalAccessTokenFromRedirect(token: string | null): void {
  if (token) {
    pendingAccessToken = token
  }
}

export function consumeMsalAccessTokenFromRedirect(): string | null {
  const t = pendingAccessToken
  pendingAccessToken = null
  return t
}

export function clearMsalAccessTokenBridge(): void {
  pendingAccessToken = null
}
